import { ApiService } from "src/network/apiService";
import { ApiResponse } from "src/network/models";
import { BusinessModel, IApproveBusinessRequest, IBusinessNumberApprovalRequest } from "src/types/models/business";

export class BusinessViewerViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async submitBusinessNumberApproval(businessId: string, number: IBusinessNumberApprovalRequest): Promise<boolean> {

        const URL = `/onboard/business/${businessId}/numbers/approve`;

        try {
            const response = await this.apiService.postAsync<ApiResponse<boolean>, [IBusinessNumberApprovalRequest]>(
                URL, [number]);

            console.log("POST: /onboard/business/{businessId}/numbers/approve", response);
            if (response) {
                if (response.scResponse && response.scResponse.code === 2000) {
                    console.log("POST: /onboard/business/approve", response.scResponse.data);
                    return true;
                }
            }
        } catch (error) {
            console.log("POST: /onboard/business/approve", error);
            return false;
        }

        return false;
    }

    async submitBusinessApproval(request: IApproveBusinessRequest): Promise<boolean> {
        try {

            const response = await this.apiService.postAsync<ApiResponse<boolean>, IApproveBusinessRequest>(
                "/onboard/business/approve", request);

            if (response) {
                if (response.scResponse && response.scResponse.code === 2000) {
                    console.log("POST: /onboard/business/approve", response.scResponse.data);
                    return true;
                }
            }

            return false;
        }
        catch (error) {
            return false;
        }
    }

    async fetchBusinessDetails(businessId: string): Promise<BusinessModel | null> {
        const response = await this.apiService.getAsync<ApiResponse<BusinessModel>>(
            `/onboard/business/${businessId}`
        );

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                // console.log("GET: /onboard/business", JSON.stringify(response));
                return response.scResponse.data;
            }

            return null;
        }

        return null;
    }
}
